import { getAuthentication } from '@/hooks/useAuthentication';
import { useSuspenseQuery } from '@apollo/client';
import {
  FIND_USER_BY_ID_V5,
  FindUsersPermissionsUserByIdV5Query,
  FindUsersPermissionsUserByIdV5QueryVariables,
  PROFILE_PAGE_V5,
  ProfilePage,
  ProfilePageV5Query,
  ProfilePageV5QueryVariables,
  UsersPermissionsUser,
} from '@edwin-group/people-graphql';
import { useProfileStore } from '../store/useProfileStore';
import { useEffect } from 'react';

export const useRoot = () => {
  const { data: pageData } = useSuspenseQuery<ProfilePageV5Query, ProfilePageV5QueryVariables>(PROFILE_PAGE_V5, {
    fetchPolicy: 'cache-first',
  });

  const { data: userData } = useSuspenseQuery<
    FindUsersPermissionsUserByIdV5Query,
    FindUsersPermissionsUserByIdV5QueryVariables
  >(FIND_USER_BY_ID_V5, {
    variables: {
      documentId: getAuthentication()?.user?.documentId || '',
    },
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (userData?.usersPermissionsUser) {
      useProfileStore.setState({
        user: userData.usersPermissionsUser as UsersPermissionsUser,
      });
    }
  }, [userData?.usersPermissionsUser]);

  useEffect(() => {
    if (pageData?.profilePage) {
      useProfileStore.setState({
        page: pageData.profilePage as ProfilePage,
      });
    }
  }, [pageData?.profilePage]);

  return {
    page: pageData?.profilePage,
    user: userData?.usersPermissionsUser,
  };
};
